/**
 * Utility to manage API URL configuration
 */

export const getApiBaseUrl = () => {
  // Production (app.cogniflock.com)
  if (window.location.hostname === 'app.cogniflock.com') {
    return 'https://app.cogniflock.com/api';
  }

  // Staging (staging.cogniflock.com) – backend serves frontend and API on same origin
  if (window.location.hostname === 'staging.cogniflock.com') {
    return `${window.location.origin}/api`;
  }

  // AWS Elastic Beanstalk
  if (window.location.hostname.includes('elasticbeanstalk.com')) {
    return `${window.location.origin}/api`;
  }

  // Local development – backend on port 4000
  const backendPort = process.env.REACT_APP_BACKEND_PORT || 4000;
  return `http://localhost:${backendPort}/api`;
};

// Helper function to construct API endpoints
export const getApiEndpoint = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  // Remove any leading slash from the endpoint
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${baseUrl}/${cleanEndpoint}`;
};
